import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'compactNumber'
})
export class CompactNumberPipe implements PipeTransform {
  transform(value: number, locale = 'en'): string {
    if (!value) return '0'
    return new Intl.NumberFormat(locale, {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 1
    }).format(value)
  }
}
